import React from "react";
import Snackbar from "@mui/material/Snackbar";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const styles = (theme) => ({
  close: {
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
});

class SimpleSnackbar extends React.Component {
  state = {
    open: true,
  };

  handleClose = () => {
    this.setState({ open: false });
    if (typeof this.props.onClose === "function") {
      this.props.onClose();
    }
  };

  render() {
    const { message, classes } = this.props;
    return (
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={this.state.open}
        autoHideDuration={this.props.autoHideDuration ?? 6000}
        onClose={this.handleClose}
        message={<span id="message-id">{message}</span>}
        action={
          <IconButton
            key="close"
            color="inherit"
            className={classes.close}
            onClick={this.handleClose}
          >
            <CloseIcon />
          </IconButton>
        }
      />
    );
  }
}

SimpleSnackbar.propTypes = {
  classes: PropTypes.object.isRequired,
  message: PropTypes.string,
  onClose: PropTypes.func,
  autoHideDuration: PropTypes.number,
};

export default withStyles(styles)(SimpleSnackbar);
